import React, { useState } from "react";
import useCompanyCapital from "../../hooks/useCompanyCapital";
import SummaryCards from "../SummaryCards/SummaryCards";
import CapitalTable from "./CapitalTable";
import CapitalFormModal from "./CapitalFormModal";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { CAPITAL_TYPE_OPTIONS } from "../../constants/capitalTypes";
import styles from "./CapitalTab.module.css";

const CapitalTab = () => {
  const {
    items,
    summary,
    filters,
    pagination,
    loading,
    updateFilters,
    goToPage,
    addItem,
    editItem,
    deleteItem,
  } = useCompanyCapital();

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const openAddModal = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const openEditModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const handleSubmit = async (payload, setFieldError) => {
    if (selectedItem) {
      await editItem(selectedItem.id, payload, setFieldError);
    } else {
      await addItem(payload, setFieldError);
    }
  };

  const requestDelete = (item) => {
    setItemToDelete(item);
  };

  const cancelDelete = () => {
    if (deleting) return;
    setItemToDelete(null);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    setDeleting(true);
    try {
      await deleteItem(itemToDelete.id);
      setItemToDelete(null);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className={styles.wrapper} dir="rtl">
      <SummaryCards summary={summary} />

      <div className={styles.toolbar}>
        <div className={styles.filters}>
          <select value={filters.Type} onChange={(e) => updateFilters({ Type: e.target.value })}>
            <option value="">كل الأنواع</option>
            {CAPITAL_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>

          <input type="date" value={filters.From} onChange={(e) => updateFilters({ From: e.target.value })} title="من تاريخ" />
          <input type="date" value={filters.To} onChange={(e) => updateFilters({ To: e.target.value })} title="إلى تاريخ" />
          <input type="text" placeholder="بحث..." value={filters.SearchTerm} onChange={(e) => updateFilters({ SearchTerm: e.target.value })} />
        </div>

        <button className={styles.addBtn} onClick={openAddModal}>+ إضافة رأس مال</button>
      </div>

      <CapitalTable items={items} loading={loading} onEdit={openEditModal} onDelete={requestDelete} />

      {pagination.totalPages > 1 && (
        <div className={styles.pagination}>
          <button disabled={!pagination.hasPreviousPage} onClick={() => goToPage(pagination.currentPage - 1)}>السابق</button>
          <span>صفحة {pagination.currentPage} من {pagination.totalPages}</span>
          <button disabled={!pagination.hasNextPage} onClick={() => goToPage(pagination.currentPage + 1)}>التالي</button>
        </div>
      )}

      <CapitalFormModal isOpen={modalOpen} onClose={closeModal} onSubmit={handleSubmit} initialData={selectedItem} />

      <ConfirmDialog
        isOpen={!!itemToDelete}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من حذف "${itemToDelete?.title}"؟ لا يمكن التراجع عن هذا الإجراء.`}
        loading={deleting}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
  );
};

export default CapitalTab;